<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i :class="edit ? 'bi bi-pencil' : 'bi bi-plus-lg'"></i>
              {{ edit ? 'Editar caja' : 'Nueva caja' }}
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="fund-name">Nombre</label>
              <input
                id="fund-name"
                v-model.trim="fund.name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': nameState === false }"
                placeholder="Nombre de la caja"
              >
              <div v-if="nameState === false" class="form-card__error">
                El nombre debe tener un mínimo de 3 letras
              </div>
              <div v-else class="form-card__hint">Campo obligatorio</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="fund-type">Tipo de caja</label>
              <q-select v-model="fund.type" :options="fundTypeOptions" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="fund-currency">Moneda</label>
              <q-select v-model="fund.currency" :options="currencyOptions" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="fund-initial">Saldo de inicio</label>
              <input
                id="fund-initial"
                v-model.number="fund.initial_amount"
                type="number"
                step="0.01"
                class="form-control"
                placeholder="0.00"
              >
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!canSave || isSaving"
              @click="saveFund()"
            >
              <i class="bi bi-check-lg"></i>
              {{ edit ? 'Modificar caja' : 'Agregar caja' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QSelect from '@/components/shared/QSelect.vue';

const emptyFund = () => ({
  id: null,
  name: "",
  currency: "$",
  notes: null,
  type: "0",
  initial_amount: null,
});

export default {
  components: { QSelect },
  props: ["fundId"],
  data() {
    return {
      fund: emptyFund(),
      edit: false,
      isSaving: false,
      optionsUnit: [
        { value: "0", text: "Efectivo" },
        { value: "1", text: "Banco" },
        { value: "2", text: "Tarjeta de crédito" },
      ],
      optionsCurrency: [
        { value: "$", text: "Pesos" },
        { value: "US$", text: "Dólares" },
      ],
    };
  },
  computed: {
    nameState() {
      const len = this.fund.name ? this.fund.name.length : 0;
      if (len === 0) return null;
      return len >= 3 ? null : false;
    },
    canSave() {
      return !!(this.fund.name && this.fund.name.trim().length >= 3);
    },
    fundTypeOptions() {
      return this.optionsUnit.map(opt => ({ value: opt.value, label: opt.text }));
    },
    currencyOptions() {
      return this.optionsCurrency.map(opt => ({ value: opt.value, label: opt.text }));
    },
  },
  mounted() {
    if (this.fundId != null) {
      this.getFund(this.fundId);
    }
  },
  methods: {
    saveFund() {
      if (!this.canSave || this.isSaving) return;
      this.isSaving = true;
      const url = this.fundId == null ? '/api/funds/add' : '/api/funds/edit/' + this.fundId;
      this.$http.post(url, this.fund).then(() => {
        this.$emit("confirmsave");
        this.$emit('close');
      }).finally(() => {
        this.isSaving = false;
      });
    },
    getFund(fundId) {
      this.edit = true;
      this.$http.get("/api/funds/getFund/" + fundId).then((response) => {
        if (response.status === 200) {
          const result = response.data.data;
          this.fund = {
            id: result.id,
            name: result.name,
            currency: result.currency,
            type: String(result.type),
            notes: result.notes || null,
            initial_amount: result.initial_amount || null,
          };
        }
      });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
